// *********************************
// Actions
// *********************************
const OPEN_DIALOG = "SESSION_EXPIRED_DIALOG/OPEN_DIALOG";
const CLOSE_DIALOG = "SESSION_EXPIRED_DIALOG/CLOSE_DIALOG";
// *********************************
// Re-export Actions as constant
// *********************************
const SESSION_EXPIRED_CONSTANT = {
  OPEN_DIALOG,
  CLOSE_DIALOG,
};
// *********************************
// Action Creators
// *********************************
function openDialog() {
  return {
    type: OPEN_DIALOG,
  };
}

function closeDialog() {
  return {
    type: CLOSE_DIALOG,
  };
}
// *********************************
// Reducer
// *********************************
const initialState = {
  show: false,
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case OPEN_DIALOG:
      return {
        ...state,
        show: true,
      };
    case CLOSE_DIALOG:
      return {
        ...state,
        show: false,
      };
    default:
      return state;
  }
}

export { SESSION_EXPIRED_CONSTANT, openDialog, closeDialog };
export default reducer;
